export default {
    namespaced:true,
    actions:{
        async getCompany(context,params){//获取公司列表
            let { data } = await axios.post('job/api/company_job/list',params);
            return data;
        }
    }
}